<template>
  <DepartmentReviews
    :heading="data.heading || 'Отзывы'"
    :department-ids="data.departmentIds || []"
    :medical-department-ids="data.medicalDepartmentIds || []"
    :limit="data.limit || 6"
    :all-reviews-text="data.allReviewsText || 'Все отзывы'"
    :all-reviews-link="data.allReviewsLink || '/about/reviews'"
  />
</template>

<script>
import DepartmentReviews from '@/components/Departments/DepartmentReviews.vue'

export default {
  name: 'AppDepartmentReviewsBlock',
  components: { DepartmentReviews },
  props: {
    data: { type: Object, default: () => ({}) },
  },
}
</script>
